import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SvgIconsSize from './SvgIconsSize';
import ClientProvider from './client';
export default createDemo(import.meta.url, SvgIconsSize, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/icons/demos/svg-size/SvgIconsSize.tsx",
    "fileName": "SvgIconsSize.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Stack from '@mui/material/Stack';\nimport SvgIcon from '@mui/material/SvgIcon';\nimport type { SvgIconProps } from '@mui/material/SvgIcon';\n\nfunction HomeIcon(props: SvgIconProps) {\n  return (\n    <SvgIcon {...props}>\n      <path d=\"M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z\" />\n    </SvgIcon>\n  );\n}\n\nexport default function SvgIconsSize() {\n  return (\n    <Stack direction=\"row\" spacing={3} sx={{ alignItems: 'flex-end' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <HomeIcon fontSize=\"small\" />\n      <HomeIcon />\n      <HomeIcon fontSize=\"large\" />\n      <HomeIcon sx={{ fontSize: 40 }} />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 22,
        "focusedLines": 4,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Stack from '@mui/material/Stack';\nimport SvgIcon from '@mui/material/SvgIcon';\nimport type { SvgIconProps } from '@mui/material/SvgIcon';\n\nfunction HomeIcon(props: SvgIconProps) {\n  return (\n    <SvgIcon {...props}>\n      <path d=\"M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z\" />\n    </SvgIcon>\n  );\n}\n\nexport default function SvgIconsSize() {\n  return (\n    <Stack direction=\"row\" spacing={3} sx={{ alignItems: 'flex-end' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <HomeIcon fontSize=\"small\" />\n      <HomeIcon />\n      <HomeIcon fontSize=\"large\" />\n      <HomeIcon sx={{ fontSize: 40 }} />\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "HomeIcon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "fontSize"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "small",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "HomeIcon"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "HomeIcon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "fontSize"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "large",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "HomeIcon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "fontSize"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "40"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 22,
    "focusedLines": 4,
    "collapsible": true,
    "externals": [
      "@mui/material/Stack",
      "@mui/material/SvgIcon"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
